import React from 'react'

function Heading({ text }: any) {
    return (
        <h3 className='text-lg font-bold text-black mb-3'>{text}</h3>
    )
}

export default Heading